import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import SydModal from '../../../../../commonDesign/SydModal'
import ModifyDatasourceAiEnabledForm from './form'

const ModifyDatasourceAiEnabledDialog = React.forwardRef(function ModifyDatasourceAiEnabledDialog ({ onComplete }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, processing: false })

  const close = useCallback(() => {
    setDialogState({ open: false, processing: false })
  }, [setDialogState])

  const handleComplete = useCallback((e) => {
    close()
    onComplete(e)
  }, [close, onComplete])

  useImperativeHandle(ref, () => ({
    open: (dataSource) => setDialogState({
      open: true,
      processing: false,
      dataSource
    })
  }), [setDialogState])

  return (
    <SydModal
      title='AI Enabled Settings'
      open={dialogState.open}
      onClose={close}
      size='md'
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (
          <ModifyDatasourceAiEnabledForm
            dataSource={dialogState.dataSource}
            onComplete={handleComplete}
            onCancel={close}
          />
        ) : null}
      </div>
    </SydModal>
  )
})

ModifyDatasourceAiEnabledDialog.propTypes = {
  onComplete: PropTypes.func
}

ModifyDatasourceAiEnabledDialog.defaultProps = {
  onComplete: () => {}
}

export default ModifyDatasourceAiEnabledDialog
